import React, { createContext, useContext, useState } from "react";

const MemberContext = createContext(undefined);
export const MemberProvider = ({
  children,
}) => {
    const [members, setMembers] = useState(null);
    const [memberDetails, setMemberDetails] = useState(null);
    return (
        <MemberContext.Provider
        value={{
            members,
            setMembers,
            memberDetails,
            setMemberDetails
        }}
        >
            {children}
        </MemberContext.Provider>
    );
};
export const useMemberContext = () => {
  const context = useContext(MemberContext);
  if (!context) {
    throw new Error("useMemberContext must be used within a MemberProvider");
  }
  return context;
};